/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const DropletSolidAddBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M13 19a6.002 6.002 0 0 1 4.588-5.833c-1.099-4.134-4.09-9.177-5.182-10.936a.472.472 0 0 0-.812 0C10.246 4.403 6 11.584 6 15.877 6 19.259 8.686 22 12 22c.58 0 1.14-.084 1.67-.24A5.975 5.975 0 0 1 13 19Zm11 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-6-2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V18h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H20v1.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V20h-1.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H18v-1.5Z" /></svg>);
const DropletSolidAdd = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={DropletSolidAddBase} {...rest} ref={ref} />);
export default DropletSolidAdd;